import * as React from "react";

import { Root } from "./Flexbox.styles";

export interface FlexboxProps {
    children: React.ReactChildren | React.ReactNode;
    inline?: boolean;
    alignContent?: "flex-start" | "flex-end" | "center" | "space-between" | "space-around" | "stretch";
    alignItems?: "flex-start" | "flex-end" | "center" | "baseline" | "stretch";
    flexDirection?: "column" | "row" | "row-reverse" | "column-reverse";
    flexWrap?: "nowrap" | "wrap" | "wrap-reverse";
    justifyContent?: "flex-start" | "flex-end" | "center" | "space-between" | "space-around" | "space-evenly";
    minWidth?: number | string;
    offsetBottom?: number | string;
    offsetLeft?: number | string;
    offsetRight?: number | string;
    offsetTop?: number | string;
    width?: number | string;
}

export function Flexbox(props: FlexboxProps): JSX.Element {
    const style = {
        flexDirection: props.flexDirection,
        flexWrap: props.flexWrap,
        justifyContent: props.justifyContent,
        alignItems: props.alignItems,
        alignContent: props.alignContent,
        marginTop: props.offsetTop,
        marginBottom: props.offsetBottom,
        marginRight: props.offsetRight,
        marginLeft: props.offsetLeft,
        minWidth: props.minWidth,
        width: props.width,
    };

    return (
        <Root inline={props.inline} style={style}>
            {props.children}
        </Root>
    );
}
